<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">
                    {{question}}
                </div>
                <button class="btn btn-primary waves-effect pull-right" type="button" v-on:click.prevent="backButton()">Back</button>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <div class="cards-container">
                    <!--<div class="drag-view">-->
                    <draggable v-model="imageList" v-on:change="changePosition()" class="drag-view">
                        <template v-for="(image, index) in imageList">
                            <div class="col-4 mb-5">
                                <div class="cards-block">
                                    <div class="card">
                                        <!--<a class="example-image-link" :href="image.image" rel="prettyPhoto[gallery]" title="">-->
                                            <img class="card-img-top" :src="image.image" :key="index" alt="Image">
                                        <!--</a>-->
                                        <div class="card-body">
                                            <button v-show="image.status == 1" class="mr-2 btn btn-danger pull-right" type="button" v-on:click.prevent="deleteQuestionImage(image.id)">
                                                <i class="fa fa-trash-o" aria-hidden="true"></i>
                                            </button>
                                            <button v-show="image.status != 1" class="mr-2 btn btn-success pull-right" type="button" v-on:click.prevent="changeQuestionImageStatus(image.id)">
                                                <i aria-hidden="true" class="fa fa-check"></i>
                                            </button>
                                            <button v-show="image.status != 1" class="mr-2 btn btn-danger pull-right" type="button" v-on:click.prevent="deleteQuestionImage(image.id)">
                                                <i aria-hidden="true" class="fa fa-times"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </draggable>
                    <!--</div>-->
                </div>
            </div>
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
</template>

<script>
    import $ from 'jquery';
    import draggable from 'vuedraggable';
    import Vue from "vue";
    import BackendFooter from '@/components/backend/partials/Footer';
    import {bTabs} from 'bootstrap-vue/es/components/tabs/tabs';
    import SessioMixin from '../../../mixins/sessionmixin';
    import {HTTP} from '../../../http-common';
    var self;
    export default {
        name: 'ListForumQuestionImage',
        mixins: [SessioMixin],
        components: {
            draggable,
            'app-backend-footer': BackendFooter,
        },
        data() {
            return {
                imageList: [],
                imagePosition: [],
                questionId: 0,
                question: "",
            }
        },
        computed: {
        },
        beforeMount: function () {
            self = this;
            self.checkLogin();
        },

        mounted: function () {
            var path = window.location.pathname;
            var segments = path.split("/")[3];
            self.questionId = segments;
            self.MenuClose();
            self.getQuestionImages();
        },
        methods: {
            backButton: function () {
                self.$router.push('/backend/forum-posts')
            },
            changeQuestionImageStatus: function (id) {
                var questionArr = [];
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };

                if (id) {
                    questionArr.push(id);
                } else {
                    var selectedQuestion = self.$refs['forumQuestionList'].selectedRows;
                    for (var i = 0; i < selectedQuestion.length; i++) {
                        questionArr.push(this.$refs['forumQuestionList'].selectedRows[i].id);
                    }
                }
                var fields = {
                    questionArr: questionArr,
                };
                this.$swal({
                    title: 'Are you sure?',
                    text: 'You can\'t revert your status change action',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes Change it!',
                    cancelButtonText: 'No, Keep it!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        HTTP.post("changequestionimagestatus", fields, config)
                                .then(function (response) {
                                    self.getQuestionImages();
                                })
                                .catch(function (err) {
                                    if (err.response.status == 0) {
                                        self.error = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            self.$router.push("/login");
                                            //EventBus.$emit("logged-in", true, "", "");
                                        }
                                    }
                                });
                        self.$swal({
                            title: 'Changed',
                            type: 'success',
                            text: 'You successfully changed status of the record(s).',
                            showConfirmButton: false,
                            timer: 3000,
                        });
                    } else {
                        self.$swal({
                            title: 'Cancelled',
                            type: 'info',
                            text: 'Your record(s) still intact',
                            showConfirmButton: false,
                            timer: 3000,
                        });
                    }
                })
            },
            deleteQuestionImage: function (id) {
                //console.log(id);
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    data: {
                        delete: id,
                    }
                };
                this.$swal({
                    title: 'Are you sure?',
                    text: 'You can\'t revert your action',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes Delete it!',
                    cancelButtonText: 'No, Keep it!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        HTTP.delete("deletequestionimage", config)
                                .then(function (response) {
                                    self.getQuestionImages();
                                })
                                .catch(function (err) {
                                    if (err.response.status == 0) {
                                        self.error = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            self.$router.push("/login");
                                            //EventBus.$emit("logged-in", true, "", "");
                                        }
                                    }
                                });
                        self.$swal({
                            title: 'Deleted',
                            type: 'success',
                            text: 'You successfully deleted the record(s).',
                            showConfirmButton: false,
                            timer: 3000,
                        });
                    } else {
                        self.$swal({
                            title: 'Cancelled',
                            type: 'info',
                            text: 'Your record(s) still intact',
                            showConfirmButton: false,
                            timer: 3000,
                        });
                    }
                });
            },
            getQuestionImages() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                var fields = {
                    question_id: self.questionId,
                };
                HTTP.post("getquestionimages", fields, config)
                        .then(function (response) {
                            self.imageList = response.data.content;
                            self.question = response.data.content[0].question;
                            setTimeout(function () {
                                jQuery("a[rel^='prettyPhoto']").prettyPhoto();
                            }, 500);
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            changePosition() {
                /*var fields = {
                    imageList: self.imageList,
                };
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                HTTP.post("changeposition", fields, config)
                        .then(function (response) {
                            self.getQuestionImages();
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                        });*/
            },
        },
    }
</script>
<style>
    .deleteMedia {
        position: unset !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/backend/forum/ListForumQuestionImages.vue